import React from 'react';
import CustomModal from './CustomModal';
import ReactMarkdown from 'react-markdown';

const BlogModal = ({ isBlogModalOpen, setIsBlogModalOpen, blogContent, isLoading }) => {
  return (
    <CustomModal
      isOpen={isBlogModalOpen}
      onRequestClose={() => setIsBlogModalOpen(false)}
      overlayClassName="react-modal-overlay"
      modalClassName="modal-base-class react-blog-modal-content"
    >
      {isLoading ? <div>Loading...</div> : <ReactMarkdown>{blogContent}</ReactMarkdown>}
      <button className="modal-close-button" onClick={() => setIsBlogModalOpen(false)}>Close</button>
    </CustomModal>
  );
};

export default BlogModal;
